<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Add Business</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-text-field label="Name" placeholder="Enter business name" required v-model="name" />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0"> Cancel </base-button>
      </div>
      <inline-error class="tw-mt-3" id="add-business-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";

export default {
  components: {
    InlineError,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      name: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    },
    show() {
      this.$refs.modal.show();
      this.reset();
    },
    hide() {
      this.$refs.modal.hide();
      this.reset();
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      try {
        this.isLoading = true;
        await this.$axios.post("/business", {
          name: this.name,
        });
        this.$emit("save");
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Business Created", message: `Business ${this.name} was created successfully` });
        this.hide();
      } catch (err) {
        this.errorTitle = `Error creating business ${this.name}`;
        this.errorMessage = "Sorry, we had trouble creating this business. The technicians have been notified. Please try again.";
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
